.button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 0 24px;
  border: var(--outline);
  border-radius: var(--radius-control);
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
}

.primary {
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
}

/* Pressing drops the shadow and moves the button into its place, the way a
 * physical key goes down. */
.primary:active {
  box-shadow: none;
  transform: translate(3px, 3px);
}

.secondary {
  background: var(--surface);
  color: var(--ink);
}

.button:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  box-shadow: none;
  cursor: default;
}
